
const initialState = {
    previousLocation: null,
    currentLocation: null,
}

const locationReducer = (state = initialState, action) => {
    switch (action.type) {
        case "LOCATION_CHANGE":
            return {
                previousLocation: state.currentLocation,
                currentLocation: action.payload.pathname,
            };
        default:
            return state
    }
}
export default locationReducer;